import type { ScheduleTRPCInput } from '@risksmart-app/trpc/src/types';
import type {
  InsertChildObligationInput,
  InsertObligationMutation,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

type InsertObligationTRPCInput = Omit<InsertChildObligationInput, 'schedule'> &
  ScheduleTRPCInput;

function mapTrpcResponseToGraphQL(trpcData: {
  Id: string;
}): InsertObligationMutation {
  return {
    insertChildObligation: {
      __typename: 'IdOutput',
      Id: trpcData.Id,
    },
  };
}

export const useInsertObligationTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.obligation.insert.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.obligation.register.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.obligation.getById.queryKey(),
        });
      },
    }),
  });

  return {
    insertObligation: async (
      variables: InsertObligationTRPCInput
    ): Promise<InsertObligationMutation> => {
      const result = await mutation.mutateAsync({
        ...variables,
        Adherence: variables.Adherence ?? '',
      });

      return mapTrpcResponseToGraphQL(result);
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
